/**
 * Phase 5b ÔÇö Verk├ñufe lesen: Domain-Aggregat-Index + merged Blob (reicher Union).
 */

import { listAggregateSales } from '../infrastructure/storage/domainAggregateStore';
import { listEntitySales } from '../infrastructure/storage/entityAggregateStore';
import { readBlobFirstWithAggregateFallback } from './canonicalEntityRead';
import { readSyncWithBlobPriority, readArrayFieldFromMergedBlob } from './businessStateSync';

/** @type {Map<string, object[]>} */
const salesReadCache = new Map();

export function readSalesFromMergedBlob(businessId) {
  return readArrayFieldFromMergedBlob(businessId, 'sales', getCachedSalesRead);
}

/**
 * Beste verf├╝gbare sales[]-Liste (IDB-Index Ôê¬ KV-Blob).
 * @param {string} businessId
 * @returns {Promise<object[]>}
 */
export async function readSalesFromBestSource(businessId) {
  return readBlobFirstWithAggregateFallback(
    businessId,
    readSalesFromMergedBlob,
    listAggregateSales,
    listEntitySales,
    ['id', 'orderId']
  );
}

/**
 * L├ñdt sales[] und h├ñlt synchronen Cache f├╝r parseSalesFromBusinessPayload.
 */
export async function refreshSalesReadCache(businessId, preloaded) {
  const sales =
    preloaded !== undefined
      ? Array.isArray(preloaded)
        ? preloaded
        : []
      : await readSalesFromBestSource(businessId);
  if (businessId) {
    salesReadCache.set(String(businessId), sales);
  }
  return sales;
}

export function getCachedSalesRead(businessId) {
  if (!businessId) return null;
  return salesReadCache.get(String(businessId)) ?? null;
}

export function clearSalesReadCache(businessId) {
  if (businessId) {
    salesReadCache.delete(String(businessId));
  } else {
    salesReadCache.clear();
  }
}

/** Synchroner Lesepfad (Cache Ôê¬ Blob, Blob-Priorit├ñt). */
export function readSalesSyncForBusiness(businessId) {
  return readSyncWithBlobPriority(
    businessId,
    readSalesFromMergedBlob,
    getCachedSalesRead,
    'id',
    'orderId'
  );
}
